//@flow

// Vendors
import React from 'react';
import { useDispatch } from 'react-redux';

// Components
import { Modal } from '../../../../modals';
import Trans from '../../../../Trans/Trans';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';

// Actions
import { closeModal } from '../../../../../../reducers/modal/modalActions';

// Styles
import '../dps-FAQ-modal.scss';

const DPS_Application_Pending_Modal = () => {
  const dispatch = useDispatch();
  return (
    <Modal name="DPS_Application_Pending_Modal" className="faq-modal">
      <h2 className="h1 modal-title-general">
        <Trans file="dps" id="dps_Application_Pending" />
      </h2>
      <p className="modal-description-general">
        <Trans file="dps" id="dps_Application_Pending_Desc" />
      </p>

      <ButtonPrimary
        className="modal-close-button-general"
        onClick={() => dispatch(closeModal('DPS_Application_Pending_Modal'))}
      >
        <Trans file="Labels" id="okGotIt" />
      </ButtonPrimary>
    </Modal>
  );
};

export default DPS_Application_Pending_Modal;
